var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "li",
    {
      staticClass: "file-chooser-tree-item",
    },
    [
      _c(
        "span",
        {
          staticClass: "folder-toggle",
        },
        [
          _vm.hasSubfolders
            ? _c(
                "a",
                {
                  attrs: {
                    herf: "#",
                    title: _vm.unfold
                      ? _vm.$gettext("Ordner zuklappen")
                      : _vm.$gettext("Ordner aufklappen"),
                  },
                  on: {
                    click: function click($event) {
                      $event.preventDefault()
                      return _vm.toggleSubfolders.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("studip-icon", {
                    attrs: {
                      shape: _vm.unfold ? "arr_1down" : "arr_1right",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          class: {
            selected: _vm.isSelected,
          },
          attrs: {
            href: "#",
          },
          on: {
            click: function click($event) {
              $event.preventDefault()
              return _vm.selectFolder.apply(null, arguments)
            },
          },
        },
        [
          _c("studip-icon", {
            attrs: {
              shape: _vm.folderIcon,
            },
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.folder.attributes.name))]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.unfold
        ? _c(
            "ul",
            {
              staticClass: "file-chooser-tree",
            },
            _vm._l(_vm.folder.children, function (child) {
              return _c(
                "li",
                {
                  key: child.id,
                  staticClass: "file-chooser-tree-item",
                },
                [
                  _c("file-chooser-tree", {
                    attrs: {
                      folder: child,
                    },
                  }),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }